export const homeDe = {
  // Hero section
  heroTitle: "Sie Kann. Sie Wird. Sie Hat Es Getan.",
  heroSubtitle: "Eine Bewegung, geboren aus Widerstandsfähigkeit, gebaut für jede Frau, der jemals gesagt wurde 'du kannst nicht.'",
  heroButton: "Unserer Gemeinschaft Beitreten",
  
  // Story section
  storyTitle: "Vom Kampf zur Stärke",
  storyText1: "SheCan wurde aus meiner eigenen Reise geboren, Widrigkeiten zu überwinden. Als Frau, die unzähligen Hindernissen gegenüberstand und öfter 'du kannst nicht' hörte, als ich zählen kann, beschloss ich, ihnen das Gegenteil zu beweisen.",
  storyText2: "Diese Bewegung ist für jede Frau, die unterschätzt, übersehen wurde oder der gesagt wurde, ihre Träume seien zu groß. Gemeinsam schreiben wir die Geschichte neu.",
  storyButton: "Meine Geschichte Lesen",
  
  // Community section
  communityTitle: "Treten Sie Einer Gemeinschaft Unaufhaltsamer Frauen Bei",
  communitySubtitle: "Verbinden, wachsen und gemeinsam gedeihen",
  communityFeature1: "Unterstützendes Netzwerk",
  communityFeature1Text: "Verbinden Sie sich mit gleichgesinnten Frauen, die Ihre Reise verstehen",
  communityFeature2: "Exklusive Veranstaltungen",
  communityFeature2Text: "Zugang zu Workshops, Webinaren und Networking-Möglichkeiten",
  communityFeature3: "Ressourcen & Werkzeuge",
  communityFeature3Text: "Erhalten Sie praktische Ressourcen, um Ihre Ziele zu erreichen",
  communityButton: "Gemeinschaft Erkunden",
  
  // Featured Products
  productsTitle: "Stärken Sie Ihre Reise",
  productsSubtitle: "Kuratierte Produkte, um Sie zu inspirieren und zu unterstützen",
  
  // Testimonials
  testimonialsTitle: "Geschichten der Transformation",
  testimonial1: "SheCan gab mir den Mut, mein eigenes Unternehmen zu gründen. Die Unterstützung der Gemeinschaft ist unglaublich!",
  testimonial1Author: "Sarah Johnson",
  testimonial1Role: "Unternehmerin",
  testimonial2: "Ich fand meine Stimme und meinen Stamm hier. Diese Bewegung veränderte mein Leben.",
  testimonial2Author: "Maria Garcia",
  testimonial2Role: "Schriftstellerin",
  testimonial3: "Die Ressourcen und Unterstützung halfen mir, meinen Karrierewechsel mit Zuversicht zu meistern.",
  testimonial3Author: "Emily Chen",
  testimonial3Role: "Karriere-Coach"
};

export default homeDe;
